export enum SearchCriteriaEnum {
    FIRST_NAME = 'FIRST_NAME',
    LAST_NAME = 'LAST_NAME',
    ROLE_GREYBEE = 'ROLE_GREYBEE',
    BRANCH_SKILLS = 'BRANCH_SKILLS',
    LANGUAGES_SKILLS = 'LANGUAGES_SKILLS',
    CERTIFICATIONS = 'CERTIFICATIONS',
    IT_SKILLS = 'IT_SKILLS',
    PROFESSIONAL_SKILLS = 'PROFESSIONAL_SKILLS',
    PROJECT_TYPE = 'PROJECT_TYPE',
    PROJECT_APPROACH = 'PROJECT_APPROACH',
    CUSTOMER = 'CUSTOMER',
    ROLE_IN_PROJECT = 'ROLE_IN_PROJECT',
    TECHNOLOGIES = 'TECHNOLOGIES',
    USER_TYPE = 'USER_TYPE'
}